export default __webpack_public_path__ + "static/media/Logo 500x500 PNG (WO- BG).png (1).21f80262.png";